__turbopack_context__.v({
  "actionIconWrapper": "styles-module__7TTvcq__actionIconWrapper",
  "backButton": "styles-module__7TTvcq__backButton",
  "modal": "styles-module__7TTvcq__modal",
  "moreToolsButton": "styles-module__7TTvcq__moreToolsButton",
  "toggleButton": "styles-module__7TTvcq__toggleButton",
  "versionInformation": "styles-module__7TTvcq__versionInformation",
  "versionInformationLink": "styles-module__7TTvcq__versionInformationLink",
});
